<template>
  <form autocomplete="off"
        class="microloan-form grid-container full"
        novalidate
        @submit.prevent="onSubmit">
    <div class="grid-x">
      <div class="cell small-12">
        <vb-form-select v-model="model.amount" v-bind="selectProps">
          <option :value="remaining">{{ $t('entireRemaining') }}</option>
        </vb-form-select>
      </div>
      <div class="cell small-12">
        <StatefulButton
          class="expanded no-chevron text-center"
          :in-progress="requestPending"
          name="submit"
          type="submit"
          @click.native.prevent="addItem">
          <span v-html="$t('submit')" />
          <FontAwesomeIcon :icon="['fac', 'chevron-right-light']" />
        </StatefulButton>
      </div>
    </div>
  </form>
</template>

<script>
  import { facChevronRightLight } from '~/assets/font-awesome-custom/fac-chevron-right-light'
  import HasMicroloanForm from '~/modules/loans/mixins/has-microloan-form'
  import i18n from './locales'
  import BasketTracker from '~/libs/tracking/analytics/trackers/basket'
  import Microloan from '~/modules/loans/entities/frontend/microloan'

  export default {
    name: 'MicroloanForm',
    i18n,
    mixins: [
      HasMicroloanForm,
    ],
    data () {
      return {
        oldBasket: null,
        list: 'Loan detail',
      }
    },
    methods: {
      addItem () {
        this.oldBasket = this.$store.getters['basket/basket']
        const xhr = this.$store.dispatch.bind(this, 'basket/add', {
          amount: this.model.amount,
          id: this.model.loanId,
          type: 'microloan',
        })

        this.callApi(xhr, this.onSuccess)
      },
      onSuccess (basket) {
        this.trackInDataLayer(basket)
        this.$router.push({
          name: 'basket:frontend:index',
        })
      },
      trackInDataLayer (basket) {
        const microloan = new Microloan({
          'amount': this.model.amount,
          'loanId': this.model.loanId,
          'entrepreneurDisplayName': this.entrepreneurDisplayName,
        })

        const tracker = new BasketTracker()
        tracker.addToCart(microloan, this.oldBasket, this.list)
        tracker.addToCart(basket.donation, this.oldBasket)
      },
    },
    created () {
      this.$fa.add(facChevronRightLight)
    },
  }
</script>

<style lang="scss" scoped>
  .microloan-form {
    button[type="submit"] {
      margin: {
        bottom: 0;
        top: 0.5rem;
      }

      svg {
        font-size: 1.45rem;
        margin-left: 0.5rem;
      }
    }
  }
</style>
